import { useState, useEffect, useCallback, useMemo, createContext, useContext } from "react";
import axios from "axios";
import { API } from "../config/constants";
import { cartHeaders } from "../config/cartId";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [cart, setCart] = useState([]);

  const fetchCart = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/cart`, { headers: cartHeaders() });
      setCart(res.data);
    } catch (error) {
      console.warn("Failed to fetch cart:", error.message);
    }
  }, []);

  useEffect(() => {
    fetchCart();
  }, [fetchCart]);

  const addToCart = useCallback(async (productId, quantity, size, color, donationPrice = null) => {
    try {
      const data = { product_id: productId, quantity, size, color };
      if (donationPrice !== null) data.donation_price = donationPrice;
      await axios.post(`${API}/cart`, data, { headers: cartHeaders() });
      fetchCart();
    } catch (error) {
      console.warn("Failed to add to cart:", error.message);
    }
  }, [fetchCart]);

  const removeFromCart = useCallback(async (itemId) => {
    try {
      await axios.delete(`${API}/cart/${itemId}`, { headers: cartHeaders() });
      fetchCart();
    } catch (error) {
      console.warn("Failed to remove from cart:", error.message);
    }
  }, [fetchCart]);

  const clearCart = useCallback(async () => {
    try {
      await axios.delete(`${API}/cart`, { headers: cartHeaders() });
      setCart([]);
    } catch (error) {
      console.warn("Failed to clear cart:", error.message);
    }
  }, []);

  const value = useMemo(() => ({ cart, addToCart, removeFromCart, clearCart, fetchCart }), [cart, addToCart, removeFromCart, clearCart, fetchCart]);

  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
